<div class="quote-pdf-page app-aul-103-24" >
  <app-policy-header></app-policy-header>
  <p  style="text-align:center; font-size:22px;">
    <b>COMMERCIAL PROPERTY QUOTE</b>
  </p>
  <p  style="text-align:center; font-size:22px;">
    <b>POLICY APPLICATION INFORMATION</b>
  </p>
  <p style="font-size:19px;">
    <b>
      This Commercial Property Policy Application Information is attached to and
      forms part of the Quote numbered {{ this.quoteDetails?.quoteNo }} - 0{{ quoteDetails?.versionNo }}
    </b>
  </p>
  <p style="font-size:14px;">
    The policy application summary below represents the information provided by
    you and used by us to consider risk acceptance and pricing. All bound
    policies are subject to an inspection process to validate and electronically
    confirm this information. Subsequently any bound risks that differ from the
    information provided by you or do not meet AUL underwriting guidelines may
    be cancelled or subject to premium adjustment.
  </p>
  <br />
  <p  style="font-size:19px;">
    <b>Named Insured Information</b>
  </p>
  <table  style="width: 100% !important;">
    <tbody>
      <tr>
        <td  style="width:75%;font-size:14px;">
          Has the Named Insured operated for more than 12 months
        </td>
        <td  style="width:25%;font-size:14px;">
          {{ this.quoteDetails?.clearanceAddressQuestion?.q1 }}
        </td>
      </tr>
      <tr>
        <td  style="width:75%;font-size:14px;">
          Has the Named Insured had any claims in the last 3 years
        </td>
        <td  style="width:25%;font-size:14px;">
          {{ this.quoteDetails?.clearanceAddressQuestion?.q2 }}
        </td>
      </tr>
    </tbody>
  </table>
  <ng-container
    *ngFor="let address of this.quoteDetails?.addressInfo; let i = index"
  >
<ng-container *ngIf="this.quoteDetails?.addressInfo?.length > 0 && i === 0">
    <table  style="width: 100% !important;">
      <tbody>
        <tr>
          <td  style="width:75%;font-size:19px;">
            <b
              >Covered Premises Address {{ i + 1 }} of
              {{ this.quoteDetails?.addressInfo?.length }}</b
            >
          </td>
          <td  style="width:25%;font-size:19px;">
            <b>Occupancy</b>
          </td>
        </tr>
        <tr>
          <td style="width:75%;">
            <b
              >{{ address?.streetNum }}, {{ address?.streetName }},
              {{ address?.unitNum ? address?.unitNum + "," : "" }}
              {{ address?.city }}, {{ address?.county }}, {{ address?.state }},
              {{ address?.zipcode }}</b
            >
          </td>
          <td  style="width: 25% !important;">
            <b>{{ address?.occupany }}</b>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-container *ngFor="let building of address?.buildings; let i = index">
      <table  style="width: 100% !important; font-size:14px;">
          <tbody>
            <tr>
              <td  style="width: 100% !important;" style="font-weight: bold;">Building {{ i + 1 }}</td>
            </tr>
          </tbody>
      </table>
      <table  style="width: 100% !important; font-size:14px;">
        <tbody>          
          <tr>
            <td  style="width: 25% !important;">Construction Type</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "CONSTTYPE") }}
            </td>
            <td  style="width: 25% !important;">Number Of Stories</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "story") }}</td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Square Footage</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "sqFt") }}</td>
            <td  style="width: 25% !important;">Year Built</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "Age") }}</td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Roof Type</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "ROOFTYPE") }}</td>
            <td  style="width: 25% !important;">Distance To Coast</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "DistanceToCoast") }}
            </td>
          </tr>
        </tbody>
      </table>
      <table  style="width: 100% !important; font-size:14px;">
        <tbody>
          <tr>
            <td  style="width: 25% !important;">Year Roof Replaced</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "roofReplaceUpdate") }}
            </td>
            <td  style="width: 25% !important;">Year Plumbing Updated</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "plumbing") }}</td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Year HVAC Updated</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "hvac") }}</td>
            <td  style="width: 25% !important;">Year Electrical Updated</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "electrical") }}
            </td>
          </tr>
        </tbody>
      </table>
      <table  style="width: 100% !important; font-size:14px;">
        <tbody>
          <tr>
            <td  style="width: 25% !important;">Protection Class</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "PcClass") }}</td>
            <td  style="width: 25% !important;">Central Monitored Burglar Alarm</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "CentralMonitoredBurglarAlarm") }}
            </td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Central Monitored Fire Alarm</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "CentralMonitoredFireAlarm") }}
            </td>
            <td  style="width: 25% !important;">Fire Protection Sprinklers</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "FireProtectionSprinklers") }}
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
  </ng-container>
</div>
  <ng-container
    *ngFor="let address of this.quoteDetails?.addressInfo; let i = index"
  >
<ng-container *ngIf="this.quoteDetails?.addressInfo?.length > 1 && i > 0">
  <div class="quote-pdf-page app-aul-103-24">
    <table  style="width: 100% !important;">
      <tbody>
        <tr>
          <td  style="width:75%;font-size:19px;">
            <b
              >Covered Premises Address {{ i + 1 }} of
              {{ this.quoteDetails?.addressInfo?.length }}</b
            >
          </td>
          <td  style="width:25%;font-size:19px;">
            <b>Occupancy</b>
          </td>
        </tr>
        <tr>
          <td style="width:75%;">
            <b
              >{{ address?.streetNum }}, {{ address?.streetName }},
              {{ address?.unitNum ? address?.unitNum + "," : "" }}
              {{ address?.city }}, {{ address?.county }}, {{ address?.state }},
              {{ address?.zipcode }}</b
            >
          </td>
          <td  style="width: 25% !important;">
            <b>{{ address?.occupany }}</b>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-container *ngFor="let building of address?.buildings; let i = index">
      <table  style="width: 100% !important; font-size:14px;">
          <tbody>
            <tr>
              <td  style="width: 100% !important;font-weight: bold;">Building {{ i + 1 }}</td>
            </tr>
          </tbody>
      </table>
      <table  style="width: 100% !important; font-size:14px;">
        <tbody>          
          <tr>
            <td  style="width: 25% !important;">Construction Type</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "CONSTTYPE") }}
            </td>
            <td  style="width: 25% !important;">Number Of Stories</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "story") }}</td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Square Footage</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "sqFt") }}</td>
            <td  style="width: 25% !important;">Year Built</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "Age") }}</td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Roof Type</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "ROOFTYPE") }}</td>
            <td  style="width: 25% !important;">Distance To Coast</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "DistanceToCoast") }}
            </td>
          </tr>
        </tbody>
      </table>
      <table  style="width: 100% !important; font-size:14px;">
        <tbody>
          <tr>
            <td  style="width: 25% !important;">Year Roof Replaced</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "roofReplaceUpdate") }}
            </td>
            <td  style="width: 25% !important;">Year Plumbing Updated</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "plumbing") }}</td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Year HVAC Updated</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "hvac") }}</td>
            <td  style="width: 25% !important;">Year Electrical Updated</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "electrical") }}
            </td>
          </tr>
        </tbody>
      </table>
      <table  style="width: 100% !important; font-size:14px;">
        <tbody>
          <tr>
            <td  style="width: 25% !important;">Protection Class</td>
            <td  style="width: 25% !important;">{{ getFactor(building?.factors, "PcClass") }}</td>
            <td  style="width: 25% !important;">Central Monitored Burglar Alarm</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "CentralMonitoredBurglarAlarm") }}
            </td>
          </tr>
          <tr>
            <td  style="width: 25% !important;">Central Monitored Fire Alarm</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "CentralMonitoredFireAlarm") }}
            </td>
            <td  style="width: 25% !important;">Fire Protection Sprinklers</td>
            <td  style="width: 25% !important;">
              {{ getFactor(building?.factors, "FireProtectionSprinklers") }}
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
  </ng-container>
  </ng-container>

